


























































































































































































































import { Component, Emit, Prop } from 'vue-property-decorator';
import Mixin from '@/mixin';
import { User } from '@/store/models';
import { validationMixin, Vuelidate } from 'vuelidate';
import messageModule from '@/store/modules/common/message.module';
import { MessageType } from '@/config/enum';
import {
  managerValidator,
  TManager
} from '@/config/validation/manager-validator';
import managerService from '@/services/common/manager.service';
import managerModule from '@/store/modules/common/manager.module';
import VPasswordInput from '@/components/items/VPasswordInput.vue';
import VPopupResetPassword from '@/components/popup/VPopupResetPassword.vue';

@Component({
  name: 'VModalManagerItem',
  components: { VPopupResetPassword, VPasswordInput },
  mixins: [validationMixin],
  validations: managerValidator
})
export default class VModalManagerItem extends Mixin {
  @Prop({ required: false }) user?: User;
  @Prop({ required: true }) isShowModal?: boolean;
  public showResetPassWord = false;

  get message() {
    return messageModule.message;
  }

  get messageType() {
    return messageModule.type;
  }

  get vUser() {
    return (this.$v as Vuelidate<TManager>).user;
  }

  get allowSubmit() {
    return !(this.vUser?.$error || this.vUser?.$invalid);
  }

  public async save() {
    this.vUser?.$touch();
    if (this.allowSubmit) {
      if (this.user?.id) {
        await managerService.updateManager(this.user?.id || -1, {
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          jobTitle: this.user.jobTitle,
          companyName: this.user.companyName,
          filterClientByOrganisation: this.user.filterClientByOrganisation,
        });
        await managerModule.loadManager(this.$route.query);
        await messageModule.showMessage({
          message: `${this.user?.firstName} ${this.user?.lastName} has been updated successfully`,
          type: MessageType.info
        });
      } else {
        await managerService.createManager({
          firstName: this.user?.firstName || '',
          lastName: this.user?.lastName || '',
          jobTitle: this.user?.jobTitle || '',
          email: this.user?.email || '',
          initialPassword: this.user?.initialPassword || '',
          companyName: this.user?.companyName || '',
          filterClientByOrganisation: this.user?.filterClientByOrganisation,
        });
        await managerModule.loadManager(this.$route.query);
        await messageModule.showMessage({
          message: `${this.user?.firstName} ${this.user?.lastName} has been created successfully`,
          type: MessageType.info
        });
      }
      this.$emit('save');
    }
  }

  public resetPassword(e) {
    e.preventDefault();
    this.showResetPassWord = !this.showResetPassWord;
  }

  @Emit()
  public cancel() {}

  mounted() {
    if (this.user?.id && this.user) {
      this.user.passwordConfirmation = 'passwordConfirmation';
      this.user.password = 'passwordConfirmation';
    }
  }
}
